import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from 'antd-v5';
import { RootState } from 'app/AppStore';
import { SheetIcon } from 'assets/icons';
import { getCurrentEstimateId, getEstimateBadgeCount } from 'domains/estimate/Estimate.store';
import { theme } from 'styles';
import { CenterFlex, Icon } from 'UI';

const EstimatesIconComponent = ({ size = 24 }: { size?: number }) => {
  const currentEstimateId = useSelector(getCurrentEstimateId);
  const estimateItemsCount = useSelector((state: RootState) => getEstimateBadgeCount(state, currentEstimateId));
  return (
    <CenterFlex>
      <Badge
        size={'small'}
        count={estimateItemsCount}
        color={theme.color.brand}
        styles={{
          indicator: {
            color: theme.color.brand_black,
            fontWeight: 'bold',
            padding: '0 3px',
          },
        }}
      >
        <Icon IconComponent={SheetIcon} color={theme.color.brand_black} size={size} display={'block'} />
      </Badge>
    </CenterFlex>
  );
};

export default EstimatesIconComponent;
